import React from 'react';
import iconLink from 'assets/icons/iconLink.svg?url';

const LinkIcon = () => {
  return <img src={iconLink} alt='Link' width='18' height='18' />;
};

export default LinkIcon;
